import { addEmailOptInToOrganization } from '../../../api/organization';
import {
    trackEmailPreferences,
    trackEmailPreferencesError,
} from '../../eventAnalytics';
import { updateEmailPreferences } from '../../../api/order';
import get from 'lodash/get';
import { getIsEbMarketingEmailOptedIn } from '../../../selectors/user';

const _handleEmailPreferencesError = (error) => {
    if (error.errors) {
        trackEmailPreferencesError(error.errors._error);

        throw error;
    }
};

export const updateEmailPreferencesForOrderOwner =
    (paymentPromise) => (dispatch, getState) =>
        paymentPromise.then(() => {
            const state = getState();
            const {
                app: {
                    featureFlags: { enableEBMarketingOptIn },
                },
                form: {
                    checkoutForm: {
                        values: {
                            ebMarketingOptIn,
                            organizationMarketingOptIn,
                            buyer: {
                                'N-first_name': firstName,
                                'N-last_name': lastName,
                                'N-email': email,
                            },
                        },
                    },
                },
                order: { id: orderId },
                organizer: { enableOrganizerMarketingOptIn },
                event: { organization },
            } = state;

            let ebOptInPromise = Promise.resolve();
            let organizationOptInPromise = Promise.resolve();

            if (getIsEbMarketingEmailOptedIn(state) !== ebMarketingOptIn) {
                ebOptInPromise = updateEmailPreferences(
                    orderId,
                    ebMarketingOptIn,
                );
            }

            if (enableOrganizerMarketingOptIn && organizationMarketingOptIn) {
                organizationOptInPromise = addEmailOptInToOrganization(
                    organization.id,
                    email,
                    firstName,
                    lastName,
                );
            }

            // We track the state of both boxes when the user submits their order so we can count how
            // many people actually saw the boxes
            if (enableEBMarketingOptIn) {
                dispatch(
                    trackEmailPreferences(
                        'RF_EB_EMAIL_OPT_IN',
                        ebMarketingOptIn,
                    ),
                );
            }

            if (enableOrganizerMarketingOptIn && get(organization, 'name')) {
                dispatch(
                    trackEmailPreferences(
                        'RF_ORG_EMAIL_OPT_IN',
                        organizationMarketingOptIn,
                    ),
                );
            }

            return Promise.all([
                ebOptInPromise,
                organizationOptInPromise,
            ]).catch((error) => _handleEmailPreferencesError(error));
        });
